import { render, staticRenderFns } from "./floorCard.vue?vue&type=template&id=228ccce2&scoped=true&"
import script from "./floorCard.vue?vue&type=script&lang=js&"
export * from "./floorCard.vue?vue&type=script&lang=js&"
import style0 from "./floorCard.vue?vue&type=style&index=0&id=228ccce2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ccce2",
  null
  
)

export default component.exports